import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompanyCreateCompany,
  CompanyFilterCompany,
  CompanyFilterWarehouse,
  CompanyUpdateCompany,
} from "../../Api/Services";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "../../Component/InputCus/Select/Select";

function CompanyAE() {
  const [isLoading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const [Warehouses, setWarehouses] = useState([]);

  const navigate = useNavigate();

  let { id } = useParams();
  const start = async () => {
    try {
      const CompanyFilterWarehouseData = await CompanyFilterWarehouse({});
      if (
        CompanyFilterWarehouseData.status &&
        CompanyFilterWarehouseData.status === 200
      ) {
        setWarehouses(CompanyFilterWarehouseData.data.data.data);
      }

      if (id) {
        const CompanyFilterCompanyData = await CompanyFilterCompany({
          id: id,
        });
        if (
          CompanyFilterCompanyData.status &&
          CompanyFilterCompanyData.status === 200
        ) {
          setForm(CompanyFilterCompanyData.data.data.data[0]);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const AddUpdate = async () => {
    let validation = true;
    if (form.name === "") {
      toast.error("نام را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const CompanyUpdateCompanyData = await CompanyUpdateCompany(form);
          if (
            CompanyUpdateCompanyData.status &&
            CompanyUpdateCompanyData.status === 200
          ) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/Companys");
          }
        } else {
          const CompanyCreateCompanyData = await CompanyCreateCompany(form);
          if (
            CompanyCreateCompanyData.status &&
            CompanyCreateCompanyData.status === 200
          ) {
            toast.success("افزودن  با موفقیت انجام شد");
            navigate("/Panel/Companys");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center w-100">
              <InputCus
                className="m-2"
                type="text"
                name="name"
                id="name"
                text="نام"
                value={form.name || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="dataConection1"
                id="dataConection1"
                text="1دیتا اتصال"
                value={form.dataConection1 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="dataConection2"
                id="dataConection2"
                text="2دیتا اتصال"
                value={form.dataConection2 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="dataConection3"
                id="dataConection3"
                text="3دیتا اتصال"
                value={form.dataConection3 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="dataConection4"
                id="dataConection4"
                text="4دیتا اتصال"
                value={form.dataConection4 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="dataConection5"
                id="dataConection5"
                text="5دیتا اتصال"
                value={form.dataConection5 || ""}
                onChange={handleChangeSearch}
              />
              <InputCus
                className="m-2"
                type="text"
                name="dataConection6"
                id="dataConection6"
                text="6دیتا اتصال"
                value={form.dataConection6 || ""}
                onChange={handleChangeSearch}
              />
              <Select
                className="m-2"
                type="number"
                name="warehouseId"
                id="warehouseId"
                text="برنامه انبارداری"
                value={form.warehouseId || ""}
                onChange={handleChangeSearch}
                option={Warehouses.map((item) => {
                  let data = {
                    value: item.id,
                    title: item.name,
                  };
                  return data;
                })}
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button onClick={AddUpdate} className="butAU">
                {id ? "ویرایش" : "افزودن"}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyAE;
